import { quiz } from '@constants/data'
import type { StepForm } from '@types'
import type { FieldValues } from 'react-hook-form'

export function transformFormData(data: StepForm, formData: FieldValues) {
  const fields = data.map((question) => question.db_field_name)
  const filteredFormData = Object.fromEntries(Object.entries(formData)?.filter(([key]) => fields.includes(key)))

  let stage = ''
  let screen = ''

  Object.entries(quiz.data.stages).forEach(([stageKey, stageValue]) => {
    Object.entries(stageValue).forEach(([screenKey, screenValue]) => {
      if (/^screen_\d+_questions$/.test(screenKey)) {
        const questions = (screenValue || []) as StepForm

        questions?.forEach((question) => {
          if (fields.includes(question?.db_field_name)) {
            stage = stageKey.match(/\d+/g)?.[0] || ''
            screen = screenKey.match(/\d+/g)?.[0] || ''
          }
        })
      }
    })
  })

  return {
    data: filteredFormData,
    stage,
    screen
  }
}
